import { Bid } from '@freelancer/datastore/bids';
import { MilestoneRequest } from '@freelancer/datastore/milestone-requests';
import { Project } from '@freelancer/datastore/projects';
import { MilestoneDraftApi } from 'api-typings/projects/projects';
import { MilestoneDraft } from './milestone-drafts.model';

export function transformMilestoneDrafts(
  milestoneDrafts: MilestoneDraftApi,
): MilestoneDraft {
  return {
    amount: milestoneDrafts.amount,
    bidderId: milestoneDrafts.bidder_id,
    bidId: milestoneDrafts.bid_id,
    currencyId: milestoneDrafts.currency_id,
    description: milestoneDrafts.description,
    id: milestoneDrafts.id,
    milestoneRequestId: milestoneDrafts.milestone_request_id,
    projectId: milestoneDrafts.project_id,
    projectOwnerId: milestoneDrafts.project_owner_id,
    timeCreated: milestoneDrafts.time_created,
    transactionId: milestoneDrafts.transaction_id,
  };
}

export function transformMilestoneDraftsFromRequest(
  milestoneRequest: MilestoneRequest,
  project: Project,
  bid: Bid,
): MilestoneDraft {
  return {
    amount: milestoneRequest.amount,
    bidderId: milestoneRequest.bidderId || bid.bidderId,
    bidId: milestoneRequest.bidId || bid.id,
    currencyId:
      (milestoneRequest.currency && milestoneRequest.currency.id) ||
      project.currency.id,
    description: milestoneRequest.description || ``,
    id: 0,
    milestoneRequestId: milestoneRequest.id,
    projectId: milestoneRequest.projectId,
    projectOwnerId: milestoneRequest.projectOwnerId || project.ownerId,
    timeCreated: Date.now(),
  };
}
